import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, Clock3Icon, CreditCardIcon, DownloadIcon, LockKeyholeIcon, UsersIcon } from 'lucide-react';
const checkoutUrl = 'https://usa.ebookpoint.shop/cart/54924045746548:1';
function formatTime(seconds: number) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor(seconds % 3600 / 60);
  const remainingSeconds = seconds % 60;
  return [hours, minutes, remainingSeconds].map(value => String(value).padStart(2, '0')).join(':');
}
export function OfferPanel() {
  const [timeLeft, setTimeLeft] = useState(43157);
  const [remaining, setRemaining] = useState(1400);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => current > 0 ? current - 1 : 43157);
      setRemaining(current => current > 1368 ? current - 1 : 1400);
    }, 60000);
    return () => window.clearInterval(timer);
  }, []);
  const claimedPercent = (1400 - remaining) / 1400 * 100;
  return <section id="offer" className="scroll-mt-5 bg-[#06172e] px-4 py-12 sm:px-6 sm:py-16" aria-labelledby="offer-title" data-id="element-100">
      <div className="mx-auto max-w-xl" data-id="element-101">
        <div className="border-l-4 border-[#f7c948] bg-white px-5 py-4 text-[#06172e] shadow-xl" data-id="element-102">
          <div className="flex items-start gap-3" data-id="element-103">
            <Clock3Icon className="mt-0.5 h-5 w-5 shrink-0 text-[#06172e]" aria-hidden="true" data-id="element-104" />
            <div data-id="element-105">
              <p className="text-xs font-black uppercase tracking-[0.15em] text-[#06172e]" data-id="element-106">
                Today&apos;s bonus window
              </p>
              <p className="mt-1 text-xl font-black tabular-nums" data-id="element-107">
                {formatTime(timeLeft)}
              </p>
              <p className="mt-1 text-xs font-semibold text-[#06172e]/70" data-id="element-108">
                Get all 5 bonuses free before the timer resets.
              </p>
            </div>
          </div>

          <div className="mt-4" data-id="element-109">
            <div className="mb-1.5 flex items-center justify-between text-xs font-bold" data-id="element-110">
              <span className="flex items-center gap-1 text-[#06172e]/75" data-id="element-111">
                <UsersIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-112" />
                Limited digital spots
              </span>
              <span className="text-[#06172e]" data-id="element-113">
                {remaining.toLocaleString()} spots remaining
              </span>
            </div>
            <div className="h-2 overflow-hidden bg-[#06172e]/10" aria-label={`${remaining} spots remaining out of 1400`} data-id="element-114">
              <div className="h-full bg-[#f7c948] transition-all duration-500" style={{
              width: `${Math.max(4, claimedPercent)}%`
            }} data-id="element-115" />
            </div>
          </div>
        </div>

        <div className="mt-5 overflow-hidden rounded-2xl border border-[#f7c948]/60 bg-[#0c2544] shadow-2xl" data-id="element-116">
          <div className="border-b border-white/10 bg-[#102f55] px-5 py-5 text-center" data-id="element-117">
            <p className="text-xs font-black uppercase tracking-[0.18em] text-[#f7c948]" data-id="element-118">
              Complete digital system
            </p>
            <h2 id="offer-title" className="mt-2 text-2xl font-black leading-tight text-white" data-id="element-119">
              Your Kit Volleyball Without Problems Order
            </h2>
          </div>

          <div className="space-y-5 p-5" data-id="element-120">
            <ul className="space-y-3 text-sm text-white" data-id="element-121">
              {['5 volumes · 255+ pages of volleyball training', '5 free today-only bonuses', '100% PDF + interactive Excel tools', 'Immediate delivery after checkout'].map(item => <li key={item} className="flex gap-2.5" data-id="element-122">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-[#f7c948]" aria-hidden="true" data-id="element-123" />
                  {item}
                </li>)}
            </ul>

            <div className="border-y border-dashed border-white/20 py-4 text-center" data-id="element-124">
              <p className="text-xs font-bold uppercase tracking-widest text-white/65" data-id="element-125">
                One-time payment
              </p>
              <div className="mt-1 flex items-end justify-center gap-3" data-id="element-126">
                <span className="pb-1 text-lg font-bold text-white/55 line-through" data-id="element-127">
                  $72 USD
                </span>
                <span className="text-4xl font-black text-[#f7c948]" data-id="element-128">
                  $25 USD
                </span>
              </div>
            </div>

            <a href={checkoutUrl} className="flex w-full items-center justify-center gap-2 bg-[#f7c948] px-5 py-4 text-center text-base font-black text-[#06172e] shadow-lg transition-colors hover:bg-[#e6b935] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white" data-id="element-129">
              <CreditCardIcon className="h-5 w-5" aria-hidden="true" data-id="element-130" />
              Start Playing Better
            </a>

            <div className="flex items-center justify-center gap-4 text-xs font-semibold text-white/70" data-id="element-131">
              <span className="flex items-center gap-1" data-id="element-132">
                <LockKeyholeIcon className="h-3.5 w-3.5 text-[#f7c948]" aria-hidden="true" data-id="element-133" />
                Secure checkout
              </span>
              <span className="flex items-center gap-1" data-id="element-134">
                <DownloadIcon className="h-3.5 w-3.5 text-[#f7c948]" aria-hidden="true" data-id="element-135" />
                Instant access
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}